import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// PrimeVue setup
import PrimeVue from 'primevue/config'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import 'primevue/resources/themes/aura-light-blue/theme.css' // or any theme
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

const app=createApp(App)

app.use(store).use(router).use(PrimeVue)

app.component('PrimeDataTable', DataTable)
app.component('PrimeColumn', Column)
app.component('PrimeInputText', InputText)
app.component('PrimeButton', Button)

app.mount('#app')

